import { t } from 'Base/modules/bk/component-property-providers/bk-translations';

const template = {
    getTemplate: () => {
        const template = document.createElement('template');
        template.innerHTML = `
          <section class="bk-modal" data-page-modal tabindex="-1" role="dialog" aria-describedby="bk-modal-body" aria-labelledby="bk-modal-label">
            <div class="bk-modal__dialog" role="document">
              <div data-modal-content class="bk-modal__content">
                <header class="bk-modal__header" data-modal-header>
                  <button data-modal-close class="bk-modal__close" aria-label="${t('global.close')}" type="button">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </header>
                <div class="bk-modal__content-container" data-modal-body></div>
              </div>
            </div>
          </section>
        `;

        return template;
    },
    getFooterWithTwoButtons: (texts) => {
        const template = document.createElement('template');
        template.innerHTML = `
        <footer class="bk-modal__footer bk-modal__footer--space-between">
          <bk-button-secondary class="bk-modal__footer-secondary" bk-text="${texts.cancelText}"></bk-button-secondary>
          <bk-button-primary class="bk-modal__footer-primary" bk-text="${texts.submitText}" bk-type="button"></bk-button-primary>
        </footer>
        `;

        return template;
    },
    getFooterWithOneButtons: (texts) => {
        const template = document.createElement('template');
        template.innerHTML = `
        <footer class="bk-modal__footer">
          <bk-button-primary class="bk-modal__footer-primary" bk-text="${texts.submitText}" bk-type="button"></bk-button-primary>
        </footer>
        `;

        return template;
    },
};

export default template;
